import { request, removeEmptyAttribute } from "../helpers/utility";

let instance = null;

export default class ContactResources {
    constructor() {
        if (!instance) {
            this.url = 'contact';
            instance = this;
        }
        return instance;
    }


    post(body) {
        let post_body = { ...body };
        post_body = removeEmptyAttribute(post_body);
        return request.POST(this.url, post_body)
    }        

    

    
}